import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';
import { DeleteShoppingListModalComponent } from './delete-shopping-list-modal.component';

export const deleteShoppingListModalLayoutConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.DELETE_SHOPPING_LIST]: {
      inlineRoot: true,
      component: DeleteShoppingListModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
      dialogOptions: {
        onTop: true,
      },
    },
  },
};
